module.exports = __webpack_public_path__ + "img/slot_ka.747b17fd.png";